import React, { useEffect, useState } from "react";
import './ValidarForm.css';
import { FaShieldAlt } from "react-icons/fa";
import Swal from 'sweetalert2'

// function getCookie(nome) {
//     var nomeEQ = nome + "=";
//     var ca = document.cookie.split(';');
//     for(var i=0;i < ca.length;i++) {
//       var c = ca[i];
//       while (c.charAt(0)===' ') c = c.substring(1,c.length);
//       if (c.indexOf(nomeEQ) === 0) return c.substring(nomeEQ.length,c.length);
//     }
//     return null;
// }

// function eraseCookie(name) {   
//     document.cookie = name+'=; Max-Age=-99999999;';  
// }

// function ValidarForm () {

//     const [autorizado, setAutorizado] = useState(null);

//     useEffect(() => {
//         const token = getCookie("info");

//         if (!token) {
//             alert("Você precisa estar logado para acessar esta página. Redirecionando...");
//             window.location.href = "/"; // Redireciona antes da renderização
//         } else {
//             setAutorizado(true); // Define como autorizado
//         }
//     }, []);

//     const [iptCodigo, setCodigo] = useState({ 
//         codigo: ""
//     });

//     const [isLoading, setIsLoading] = useState(false);

//     const validar = (evento) => {  

//         var token_autorizado = getCookie("info")
        
//         setIsLoading(true);
//         evento.preventDefault(); 

//         Swal.fire({
//             html: 'Verificando o seu login...',
//             imageUrl: 'ufo.gif',
//             imageWidth: 100,
//             imageHeight: 100,
//             allowEscapeKey: false,
//             allowOutsideClick: false,
//             didOpen: () => {
//               Swal.showLoading()
//             }
//         })

//         fetch(`${process.env.REACT_APP_API_URL}/api/autenticacoes/validar_acesso_otp`, {

//             method: 'POST',
//             headers: {
//                 'Authority': token_autorizado,
//                 'Accept': 'application/json',
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({
//                 codigo: iptCodigo.codigo,
//             })
//         })
//         .then((response) => response.json())
//         .then((result) => {
//             setIsLoading(false);

//             if(result.status === "erro"){
//                 Swal.fire({
//                     text: result.mensagem,
//                     icon: "error"
//                 })  
//                 setCodigo({ codigo: "" });
//             } else {
//                 Swal.fire({
//                     title: "Conexão estabelecida!",
//                     text: "Seu acesso foi autorizado.✨🚀",
//                     icon: "success",

//                 }).then(function() {
//                     setCookie("info", result.token,1)     
//                     window.location = "/principal" 
//                 });
//                 setCodigo({ codigo: "" });
//             }   
//         })
//         .catch((error) => {
//             setIsLoading(false);
//             console.log(error);
//             Swal.fire({
//                 title: "Ops!",
//                 text: "Parece que um UFO causou uma interferência. Por favor, tente novamente mais tarde.",
//                 icon: "info"
//             });
//         });

//     };

//     const detectar_tecla_enter = (evento) => {
//         if (evento.key === 'Enter') {
//             validar(evento); 
//         }
//     };
    
//     function setCookie(nome,valor,dias) {
//         var expires = "";
//         if (dias) {
//           var data = new Date();
//           data.setTime(data.getTime() + (24*60*60*1000));
//           expires = "; expires=" + data.toGMTString();
//         }
//         document.cookie = nome + "=" + (valor || "")  + expires + "; path=/";
//     }

//     if (autorizado === null) {
//         return null; // Não renderiza nada até validar
//     }

//     return (
//         <div className='validar-box'>
//                 <img src="telescope.png" className="logo"/>
//                 <h1>Autenticação Multifator</h1>
//                 <h4>Sua conta está protegida com autenticação 2FA. Insira abaixo o código gerado pelo aplicativo de autenticação</h4>
//                 <div className="input-box">
//                     <input 
//                     id="iptCodigo" 
//                     value={iptCodigo.codigo} 
//                     onChange={e => { setCodigo({...iptCodigo, codigo: e.target.value})}} 
//                     onKeyDown={detectar_tecla_enter}
//                     type="text" 
//                     placeholder='Codigo' required/>    
//                     <FaShieldAlt className="icon"/>
//                 </div>
//                 <button-container>
//                     <button onClick={validar} disabled={isLoading}>
//                         {isLoading ? <span className="spinner"></span> : "Validar"}  
//                     </button>
//                 </button-container>            
//         </div>       
//     );
// }

// Utilitarios

function getCookie(nome) {
    var nomeEQ = nome + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nomeEQ) === 0) return c.substring(nomeEQ.length,c.length);
    }
    return null;
}

function setCookie(nome,valor,dias) {
    var expires = "";
    if (dias) {
        var data = new Date();
        data.setTime(data.getTime() + (24*60*60*1000));
        expires = "; expires=" + data.toGMTString();
    }
    document.cookie = nome + "=" + (valor || "")  + expires + "; path=/";
}

export async function validarOTP(codigo, tipo, callbackSuccess, callbackError, setIsLoading) {
    const token = getCookie("info");
  
    setIsLoading(true);
  
    Swal.fire({
      html: 'Verificando o seu login...',
      imageUrl: 'ufo.gif',
      imageWidth: 100,
      imageHeight: 100,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/autenticacoes/validar_acesso_otp`, {
        method: 'POST',
        headers: {
            'Authority': token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ codigo }),
        });
  
        const result = await response.json();
        setIsLoading(false);
  
        if (result.status === "erro") {
            Swal.fire({ text: result.mensagem, icon: "error" });
            callbackError();
        } else {
            if (tipo === "login") {
                Swal.fire({
                    title: "Conexão estabelecida!",
                    text: "Seu acesso foi autorizado.✨🚀",
                    icon: "success",
                }).then(() => {
                    setCookie("info", result.token, 1);
                    window.location = "/principal";
                });
                    callbackSuccess();
            } else {
                if (tipo === "validacao") {
                    Swal.fire({
                        title: "Validação feita com sucesso!",
                        text: "Seu acesso foi autorizado.✨🚀",
                        icon: "success",
                    }).then(() => {
                        setCookie("info", result.token, 1);
                        callbackSuccess();
                    });         
                }
            }
        }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      Swal.fire({
        title: "Ops!",
        text: "Parece que um UFO causou uma interferência. Por favor, tente novamente mais tarde.",
        icon: "info",
      });
      callbackError();
    }
}

export default function ValidarForm() {
    const [autorizado, setAutorizado] = useState(null);
    const [codigo, setCodigo] = useState("");
    const [tipo, setTipo] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const token = getCookie("info");
        if (!token) {
            alert("Você precisa estar logado para acessar esta página. Redirecionando...");
            window.location.href = "/";
        } else {
            setAutorizado(true);
        }
    }, []);

    const handleSubmit = (evento) => {
        evento.preventDefault();
        validarOTP(
            codigo,
            "login",
            () => setCodigo(""),
            () => setCodigo(""),
            setIsLoading
        );
    };

    const detectarTeclaEnter = (evento) => {
        if (evento.key === 'Enter') {
            handleSubmit(evento);
        }
    };

    if (autorizado === null) return null;

    return (
        <div className='validar-box'>
            <img src="telescope.png" className="logo" alt="Logo" />
            <h1>Autenticação Multifator</h1>
            <h4>Sua conta está protegida com autenticação 2FA. Insira abaixo o código gerado pelo aplicativo</h4>
            <div className="input-box">
                <input
                    id="iptCodigo"
                    value={codigo}
                    onChange={(e) => {
                        if (e.target.value.length <= 6) {
                            setCodigo(e.target.value);
                        } else {
                            Swal.fire({
                                title: "Limite atingido!",
                                text: "O código deve ter no máximo 6 caracteres.",
                                icon: "warning",
                                timer: 2000,
                                showConfirmButton: false
                            });
                        }
                    }}
                    onKeyDown={detectarTeclaEnter}
                    type="text"
                    placeholder='Código'
                    required
                />
                <FaShieldAlt className="icon" />
            </div>
            <div className="button-container">
                <button onClick={handleSubmit} disabled={isLoading}>
                    {isLoading ? <span className="spinner"></span> : "Validar"}
                </button>
            </div>
        </div>
    );
}